
import React from 'react';
import './FacultyofSciences.css'

import {  FcLibrary } from "react-icons/fc";
import MegaNavbar from '../Components/MegaNavbar';
import Footer from '../Components/Footer';


const categories = [
  { icon: < FcLibrary  />, name: 'Biochemistry', link: '/Biochemistry' },
  { icon: <   FcLibrary />, name: 'Bioinformatics', link: '/Bioinformatics' },
  { icon: < FcLibrary  />, name: 'Biotechnology', link: '/Biotechnology' },
  { icon: < FcLibrary />, name: 'Botany', link: '/Botany' },
  { icon: < FcLibrary />, name: 'Chemistry', link: '/Chemistry' },
  { icon: < FcLibrary />, name: 'Computer Science', link: '/Computer' },
  { icon: < FcLibrary />, name: 'Mathematics', link: '/Mathematics' },
  { icon: < FcLibrary />, name: 'Microbiology', link: '/Microbiology' },
  { icon: < FcLibrary />, name: 'Statistics', link: '/Statistics' },
  { icon: < FcLibrary />, name: 'Zoology', link: '/Zoology' },
  // { icon: < FcLibrary />, name: 'Food and Nutrition', link: '/Food and Nutrition' },

];

const Facultyofsocialscience = () => {
  return (

    <>
    <MegaNavbar/>

   
    <div className="top-categories container">
      <h2>Faculty of Sciences</h2>
      <div className="category-container">
        {categories.map((category, index) => (
          <div key={index} className="category-card">
            <div className="icon-container">{category.icon}</div>
            <h3>{category.name}</h3>
            <a href={category.link}>View More →</a>
          </div>
        ))}
      </div>
    </div>
<Footer/>
    </>
  
  )
}

export default Facultyofsocialscience








